<template lang="pug">
TransitionExpand
  form.prose.dark_prose-invert.p-4.relative.w-full.max-w-full(
    @submit="submit"
    ref="form"
    v-if="toValue(open)"
  )
    button.btn.btn-icon.opacity-50.aspect-square.flex.items-center.justify-center.font-bold.text-xl.w-8.h-8.absolute.top-4.right-4(
      @click="close"
      type="button"
    ) &times;

    h3 Discard your changes

    p.opacity-70.max-w-full.w-96 Any changes you've made will be lost and the last saved version will be reloaded.
    p.text-bolder.max-w-full.w-96 Are you sure you want to proceed?

    UnsavedChangesDiff.mt-4.mb-6(:draft="draft")

    p.flex.gap-6 
      button.btn.btn.ripple.px-4.py-2.bg-red-600.btn-hover_bg-red-700.dark_bg-red-600.dark_btn-hover_bg-red-700.dark_ripple_bg-red-500.dark_ripple_bg-opacity-20.dark_text-gray-100.disabled_saturate-0.disabled_opacity-50.text-gray-100(
        type="submit"
      ) Discard
      p.text-xs.text-right &nbsp; {{ submitMessage }}
</template>

<script setup lang="ts">
import TransitionExpand from './TransitionExpand.vue';
import { ref, computed, toValue } from 'vue';
import type { Ref } from 'vue';
import { deleteDraft } from '../../lib/callModContent';
import { useRouter } from 'vue-router';
import { clearCourse } from '../store/courses';
import UnsavedChangesDiff from './UnsavedChangesDiff.vue';

const router = useRouter();

const props = defineProps<{
  open: boolean | Ref<boolean>;
  draft: CourseDraft | null;
  baseCourse?: CourseDraft | null;
}>();
const emit = defineEmits(['close', 'success']);
const message = ref('');
const clearOnClose = ref(false);
const submitStatus = ref<'idle' | 'pending' | 'success' | 'error' | 'redirect'>(
  'idle'
);

const submitMessage = computed(() => {
  switch (submitStatus.value) {
    case 'pending':
      return 'Discarding...';
    case 'success':
      return 'Success!';
    case 'error':
      return 'Something went wrong.';
    case 'redirect':
      return 'Reloading...';
    default:
      return '';
  }
});

const close = () => {
  emit('close');
};

const submit = async (e: Event) => {
  e.preventDefault();
  submitStatus.value = 'pending';

  if (!props.draft) {
    submitStatus.value = 'error';
    return;
  }

  try {
    await Promise.all([
      new Promise(resolve => setTimeout(resolve, 1000)),
      deleteDraft(props.draft?.id || '')
    ]);
    clearCourse({
      courseId: props.draft?.courseId,
      firmCode: props.draft?.firmCode
    });
    submitStatus.value = 'success';
    emit('success');
  } catch (e) {
    submitStatus.value = 'error';
  }

  if (submitStatus.value === 'success') {
    setTimeout(() => {
      submitStatus.value = 'redirect';
    }, 500);
    setTimeout(() => {
      router.go(0);
    }, 1000);
  }
};
</script>
